import React from "react";
import "./RecentSales.css";

const salesData = [
  { name: "Challenger Sweepers Pvt Ltd", email: "challenge.sweepers@email.com", amount: "+$1,999.00" },
  { name: "Dan Hydraulics", email: "dan.hydraulics@email.com", amount: "+$39.00" },
  { name: "Ruhfus India Pvt. Ltd.", email: "ruhfus.india@email.com", amount: "+$299.00" },
  { name: "HERRENKNECHT INDIA PVT. LTD. ", email: "herrenknecht.india@email.com", amount: "+$99.00" },
  //   { name: "Sofia Davis", email: "sofia.davis@email.com", amount: "+$39.00" }
];

const getInitials = (name) => {
  return name
    .split(" ")
    .map((n) => n[0])
    .join("");
};

const RecentSales = () => {
  return (
    <div className="recent-sales-card" style={{ height: '400px' }}>
      <div className="sales-header">
        <div className="tracking-tight text-sm font-medium">Recent Sales</div>
        <div className="text-xs text-muted-foreground mb-0">You made 265 sales this month.</div>
      </div>
      <div className="sales-list">
        {salesData.map((sale, index) => (
          <div key={index} className="sales-item">
            <span className="avatar">{getInitials(sale.name)}</span>
            <div className="sales-info">
              <p className="tracking-tight text-sm font-medium mb-0">{sale.name}</p>
              <p className="text-xs text-muted-foreground mb-0">{sale.email}</p>
            </div>
            <div className="sales-amount">{sale.amount}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RecentSales;